const prefix = (id: string) => `Rewards.${id}`

export const RewardsE2E = {
  Ids: {
    Press: {
      PointsLedger: prefix('Press.PointsLedger'),
      PointsLedgerBack: prefix('Press.PointsLedgerBack'),
    },
    View: {
      RewardsIndex: prefix('View.RewardsIndex'),
      PointsLedger: prefix('View.PointsLedger'),
    },
    Input: {},
  },
}
